import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'
import {
  Box,
  Chip,
  Divider,
  IconButton,
  Paper,
  Typography,
} from '@mui/material'
import { ChevronRight } from '@mui/icons-material'

import TwoFactorActiveOneComponent from './active-step-one.component'
import TwoFactorActiveTwoComponent from './active-step-two.component'
import TwoFactorActiveThreeComponent from './active-step-three.component'

import TwoFactorDisableOneComponent from './disable-step.component'
import useTwoFactor from '../hooks/use-two-factor.hook'
import ActionsComponent from './actions.component'

import BackupCodesComponent from './backup-codes.component'

const TwoFactorComponent = () => {
  const { t } = useTranslation()

  const {
    formikTwoFactor,
    activeStep,
    twoFactorVerified,
    loggedUser,
    section,
    backupCodes,
    handleBack,
    handleNext,
    handleStep,
    handleShowSection,
    handleHideSection,
    handleGetSecretCode,
    handleOnSubmit,
    handleGenerateBackupCodes,
  } = useTwoFactor()

  const getDialogActiveContent = () => {
    switch (activeStep) {
      case 1:
        return (
          <TwoFactorActiveOneComponent
            activeStep={activeStep}
            twoFactorVerified={twoFactorVerified}
            handleStep={handleStep}
            handleGetSecretCode={handleGetSecretCode}
          />
        )

      case 2:
        return <TwoFactorActiveTwoComponent activeStep={activeStep} />

      case 3:
        return (
          <TwoFactorActiveThreeComponent
            twoFactorVerified={twoFactorVerified}
          />
        )

      default:
        return <></>
    }
  }

  return (
    <>
      <Box mb={3} mt={6} component={Paper} p={2}>
        <Box display="flex" justifyContent="space-between" pb={2}>
          <Typography variant="h6">{t('twoFactor.twoFactorTitle')}</Typography>
          <Chip
            sx={{ minWidth: 100 }}
            variant="outlined"
            size="medium"
            label={
              loggedUser.twoFactorAuthActive
                ? t('status.enabled')
                : t('status.disabled')
            }
            className={`${
              loggedUser.twoFactorAuthActive ? 'green' : 'orange-dark'
            }`}
          />
        </Box>
        <Divider light />
        {section === 'main' ? (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              my={2}
            >
              <Typography component="p">
                {loggedUser.twoFactorAuthActive
                  ? t('twoFactor.disableTwoFactor')
                  : t('twoFactor.enableTwoFactor')}
              </Typography>
              <Box width={30}>
                <IconButton onClick={() => handleShowSection('twoFactor')}>
                  <ChevronRight />
                </IconButton>
              </Box>
            </Box>
            {loggedUser.twoFactorAuthActive && (
              <>
                <Divider light />
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  my={2}
                >
                  <Box>
                    <Typography component="p">
                      {t('twoFactor.alternativeVerificationCodes')}
                    </Typography>
                    <Typography component="p" variant="caption">
                      {t('twoFactor.alternativeVerificationSubtitle')}
                    </Typography>
                  </Box>
                  <Box width={30}>
                    <IconButton onClick={() => handleShowSection('codes')}>
                      <ChevronRight />
                    </IconButton>
                  </Box>
                </Box>
              </>
            )}
          </>
        ) : section === 'codes' ? (
          <BackupCodesComponent
            email={loggedUser.email}
            backupCodes={backupCodes}
            handleGenerateBackupCodes={handleGenerateBackupCodes}
            handleHideAction={handleHideSection}
          />
        ) : (
          <FormikProvider value={formikTwoFactor}>
            <>
              {!loggedUser.twoFactorAuthActive ? (
                getDialogActiveContent()
              ) : (
                <TwoFactorDisableOneComponent
                  twoFactorVerified={twoFactorVerified}
                />
              )}
              <ActionsComponent
                activeStep={activeStep}
                loggedUser={loggedUser}
                handleBack={handleBack}
                handleNext={handleNext}
                handleHideAction={handleHideSection}
                handleOnSubmit={handleOnSubmit}
              />
            </>
          </FormikProvider>
        )}
      </Box>
    </>
  )
}

export default TwoFactorComponent
